import { CommonModule } from "@angular/common";
import { Component, Injectable, OnInit, forwardRef } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule, ModalController, NavController, NavParams, ToastController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { noWhitespaceValidator } from "src/app/pipes/no-white-space-validator/no-white-space-validator";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";

@Component({
  selector: "app-anotacao-add",
  templateUrl: "./anotacao-add.page.html",
  styleUrls: ["./anotacao-add.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, ReactiveFormsModule],
})
export class AnotacaoAddPage implements OnInit {
  validations_form: FormGroup;
  validation_messages = {
    anotacao: [
      { type: "required", message: this.translate.instant("Campo Obrigatório") },
      { type: "whitespace", message: this.translate.instant("A descrição não pode conter apenas espaços.") },
    ],
  };
  entidade: any = "";
  idEntidade: any = "";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController
  ) {
    this.validations_form = this.formBuilder.group({
      anotacao: new FormControl("", [Validators.required, noWhitespaceValidator]),
    });
    this.entidade = this.navParams.get("entidade");
    this.idEntidade = this.navParams.get("idEntidade");
  }

  ngOnInit() {}

  onSubmit(form: { anotacao: any }) {
    this.pessoaProvider.criarAnotacao(this.entidade, this.idEntidade, form.anotacao).subscribe(async (data) => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Anotação criado com sucesso!"),
        duration: 3000,
      });

      toast.present();

      this.modalCtrl.dismiss(data);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
